import type { VTokenAssets } from 'libs/tokens/types';

export const vTokenAssets: VTokenAssets = {};
